import { promptVars } from '../variables';
import { schemaBasePrompt } from './schemaBasePrompt';
export const schemaFixPrompt = schemaBasePrompt
    .temp(0.5)
    .model('us.anthropic.claude-3-5-sonnet-20240620-v1:0')
    .human(`
# Current model:
${promptVars.modelStmts}

# There are some issues with the model. Please fix them.
${promptVars.errors}

Return only DSL that is needed to update defined model. DO NOT include anything else.
`);
//# sourceMappingURL=schemaFixPrompt.js.map